module.exports = __webpack_public_path__ + "img/technology_icon_05.f12d16c1.png";